import { CreateCalendarEventForm } from "app/services/api/types/calendar/requests/CreateCalendarEventForm";
import { Control, Controller } from "react-hook-form";
import { Text, TextInput, Pressable, View } from "react-native";
import { Button, ButtonText } from "ui/gluestack/button";
import { AlertCircleIcon, CloseIcon, Icon } from "ui/gluestack/icon";

interface Props {
  control: Control<CreateCalendarEventForm>;
  showCancel?: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  onClose: () => void;
  isSubmitting?: boolean;
}

export const EventHeader = ({
  control,
  showCancel,
  onCancel,
  onSubmit,
  onClose,
  isSubmitting,
}: Props) => {
  return (
    <View className="pb-2">
      <View className="flex flex-row  justify-between lg:gap-x-14 gap-x-10">
        <Controller
          control={control}
          name="title"
          rules={{
            required: { value: true, message: "Title is required" },
          }}
          render={({
            field: { onChange, value, onBlur },
            fieldState: { error },
          }) => (
            <View className="flex-column gap-y-2 flex-1">
              <TextInput
                value={value}
                onChangeText={onChange}
                onBlur={onBlur}
                className="text-gray-700 font-semibold text-lg border-b border-gray-300"
                placeholder="Add title"
                aria-label="Title"
              />
              {error && (
                <View className="flex-row gap-x-1 items-center">
                  <Icon
                    as={AlertCircleIcon}
                    className="text-error-500"
                    size="sm"
                  />
                  <Text className="text-red-500 text-sm">{error.message}</Text>
                </View>
              )}
            </View>
          )}
        />

        <View className="flex-row gap-x-3 h-fit ">
          {showCancel ? (
            <Button
              action="primary"
              size="sm"
              variant="outline"
              onPress={onCancel}
              isDisabled={isSubmitting}
            >
              <ButtonText>Cancel</ButtonText>
            </Button>
          ) : null}
          <Button
            action="primary"
            size="sm"
            variant="solid"
            onPress={onSubmit}
            isDisabled={isSubmitting}
          >
            <ButtonText>Save</ButtonText>
          </Button>
          <Pressable onPress={onClose} className="justify-center">
            <Icon as={CloseIcon} className="w-6 h-6" />
          </Pressable>
        </View>
      </View>
    </View>
  );
};
